import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { func } from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
import details from "assets/constants/config/config.js";
import { Grid } from "@material-ui/core";
import DesktopHeader from "./DesktopHeader";
import brandTheme from "brandTheme/Theme";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: brandTheme.headerBackGroundColor,
    width: "100%",
    height:'auto',
  },
}));

const Header = ({ handleDrawerToggle, userDetailData}) => {
  const classes = useStyles();
  const [logo, setLogo] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  useEffect(()=>{
    if(!logo){
    GetLogoLink();}
  },[logo])
  const GetLogoLink = () => {
  apiHandler({
    url: endpoint.LOGO_URL,
    method: "GET",
    authToken: authToken,
  })
    .then((result) => {
     if (result?.data?.logo) {
        setLogo(result?.data?.logo);
      }
    })
    .catch((error) => {
      console.error("Logo API Error:", error);
    })
    .finally(() => {
      console.error("Logo API Exit:");
    });
};
  return (
    <Grid container className={classes.container}>  
          <Grid item xs={8} sm={8} md={5} lg={5}className={classes.label}>
       {logo &&  <span>
           <Link to="/admin/dashboard" style={{height: 'auto', display: 'block'}}>
            {logo &&
              <img src={logo} alt="Logo" height="60" style={{margin: '10px 0px 0px 20px'}}/>
            }
          </Link>
        </span>
}
      </Grid>
      <Grid item xs={4} sm={4} md={7} lg={7} className={classes.label}>
        <Hidden smDown implementation="css">
          <DesktopHeader userDetailData={userDetailData}/>
        </Hidden>
        <Hidden mdUp implementation="css">
          <IconButton
            color="#2f2f2f"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu style={{ color: "#2f2f2f" }} />
          </IconButton>
        </Hidden>
      </Grid>
      {callInProgress && (
        <CircularProgresss callInProgress={callInProgress} />
      )}
    </Grid>
  )
};

Header.propTypes = {
  handleDrawerToggle: func,
};
export default Header;
